// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportBodyContent.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * Report Body Content component
 */

import React, { Component, PropTypes } from 'react';
import connect from 'share/enhancers/Izenda.Connect';
import GridView from 'share/components/controls/GridLayout/Izenda.GridView';
import GridItem from 'share/components/controls/GridLayout/Izenda.GridItem';
import Dimensions from 'share/components/hoc/Izenda.Dimensions';
import ReportPartContainer from './Izenda.ReportPartContainer';
import ReportBodyLayoutUIStore from './Izenda.ReportBodyLayoutUIStore';
import { get, find, placeholder } from 'lodash/fp';

@connect(Dimensions)
export default class ReportBodyContent extends Component {
  layoutStore: null;

  reportParts: [];

  static propTypes: {
    store: PropTypes.object,
    exportFormatSetting: PropTypes.object,
    doesBreakPage: PropTypes.bool,
    pageBreakAfterReportPart: PropTypes.bool
  };

  componentWillMount() {
    this.layoutStore = new ReportBodyLayoutUIStore(
      null, // width,
      true, // fullSize,
      false, // infinityRows,
      false // infinityCols
    );
    this.initReportParts(this.props);
  }

  componentWillReceiveProps(nextProps) {
    const nextReportParts = this.getReportParts(nextProps);

    this.reportParts.length !== nextReportParts.length && this.initReportParts(nextProps);
  }

  getReportParts(props) {
    const partsToRender = get('partsToRender', props);
    const store = props.store;
    const reportBody = store.reportBody;
    return partsToRender || reportBody.activeReportParts;
  }

  initReportParts(props) {
    this.reportParts = this.getReportParts(props);

    if (props.printingMode && props.doesBreakPage) {
      // Order by position Y and then X
      this.reportParts = placeholder(this.reportParts.slice())
        .sortBy(['positionY', 'positionX'])
        .value();
    }
  }

  render() {
    const props = this.props;
    const store = props.store;

    const snapToGrid = store.reportBody.snapToGrid;
    const layoutStore = this.layoutStore;
    const layoutData = this.reportParts.map(item => ({
      id: item.id,
      x: item.positionX,
      y: item.positionY,
      width: item.width,
      height: item.height,
      isFullSize: false,
      autoSize: item.autoSize
    }));

    return (
      <div className="report-body">
        <GridView
          className="report-body-grid u_fullSize"
          ref="gridView"
          printingMode={props.printingMode}
          editable={!props.viewMode}
          layoutStore={layoutStore}
          layoutData={layoutData}
          snapToGrid={snapToGrid}
        >
          {this.renderListReportPart()}
        </GridView>
      </div>
    );
  }
  renderListReportPart() {
    const props = this.props;
    const store = props.store;
    const printingMode = props.printingMode;
    const hideGridPopup = props.hideGridPopup;
    const doesBreakPage = props.doesBreakPage;
    const renderListeners = props.renderListeners;
    return this.reportParts.map((item, index) => {
      const renderListener = find(listener => listener.partId === item.id, renderListeners);

      return (
        <GridItem
          key={item.id}
          id={item.id}
          printingMode={printingMode}
          isDraggable={false}
          isResizable={!item.autoSize}
          doesBreakPage={doesBreakPage}
          isFirstItem={index === 0}
        >
          <ReportPartContainer
            isSnapEditOn={this.layoutStore.isSnapEditOn}
            gridItem={item}
            store={store}
            hideGridPopup={hideGridPopup}
            autoSize={item.autoSize}
            viewMode={props.viewMode}
            printingMode={printingMode}
            setting={props.setting}
            pageBreakAfterReportPart={props.pageBreakAfterReportPart}
            doesBreakPage={props.doesBreakPage}
            exportFormatSetting={props.exportFormatSetting}
            finishedRender={renderListener && renderListener.resolve}
            isFirstReportPart={index === 0}
            isLastReportPart={index === this.reportParts.length - 1}
          />
        </GridItem>
      );
    });
  }
}



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/ReportBody/Izenda.ReportBodyContent.js